/**
 * @type {Object}
 * @property {array}  data  Item Tag data
 */
 const initialState = {
    itemtags: []
};

/**
 * 
 * @param {Object} state    Initial state of store 
 * @param {Object} action   action data
 * @returns {Object} newState 
 */
const reducerItemTag = (state = initialState, action) => {
    const newState = { ...state }
    switch(action.type) {
        case 'FETCH_ITEM_TAG_DATA':
            var { data } = action;
            newState.itemtags = data;
            break;
        
        default:
            break;
    }
    return newState;
}

export default reducerItemTag;